export enum GGCustomMessageType {
    orderPaymentCard = "orderPaymentCard", // This is for actioncard by which order can be placed by freelancer
    orderProposalActionTakenCard = "orderProposalActionTakenCard", // This is a custom msg which tells the other party that some action has been taken by either freelancer / client regarding an order proposal
    revisionRequestCard = "revisionRequestCard", // this is when a order revision request is made by the client
    progressReviewCard = "progressReviewCard", // This is when a progress review is shared by the freelancer
    orderSubmittedBySellerCard = "orderSubmittedBySellerCard", // This is when a delivery is made by the freelancer and it awaiting client action
    orderCompletedCard = "orderCompletedCard" // This marks the order being accepted by the client
}

export interface CustomMessageOrderMetaDetails {
    buyerId: string;
    sellerId: string;
}

export interface OrderPaymentCardDetails {
    type: GGCustomMessageType.orderPaymentCard;
    actionCardId: string;
}

export enum OrderProposalActionType {
    accepted = "accepted",
    revoked_by_seller = "revoked_by_seller",
    rejected_by_buyer = "rejected_by_buyer"
}
export interface OrderProposalActionTakenCardDetails {
    type: GGCustomMessageType.orderProposalActionTakenCard;
    orderAction: OrderProposalActionType;
    orderMetaData: CustomMessageOrderMetaDetails;
}

export interface RevisionRequestCardDetails {
    type: GGCustomMessageType.revisionRequestCard;
    revisionId: string;
}

export interface ProgressReviewCardDetails {
    type: GGCustomMessageType.progressReviewCard;
    progressReviewId: string;
}

export interface OrderSubmittedBySellerCardDetails {
    type: GGCustomMessageType.orderSubmittedBySellerCard;
    orderId: string;
    orderMetaData: CustomMessageOrderMetaDetails
}

export interface OrderCompletedCardDetails {
    type: GGCustomMessageType.orderCompletedCard;
    orderId: string;
    orderCompletionTimeStamp: number
    orderMetaData: CustomMessageOrderMetaDetails
}

export type GGCustomMessageDetails =
    | OrderPaymentCardDetails
    | OrderProposalActionTakenCardDetails
    | RevisionRequestCardDetails
    | ProgressReviewCardDetails
    | OrderSubmittedBySellerCardDetails
    | OrderCompletedCardDetails;